export const transportData = {
  route: "Vaal → Venda",

  pickupPoints: [
    "Thohoyandou Thavhani Mall 09:30am",
    "Zwikwengani",
    "Tshakhuma",
    "Elim",
    "Nzhelele",
    "Louis Trichardt 11:30am",
    "Polokwane ",
    "Naboom"
  ],

  dropoffLocations: [
    "Vaal University of Technology Main Gate  ",
    "North-West University (Vanderbijlpark)",
    "Midrand New Road Engen"
  ],
  pickupTransport: [
    "Venda → Vaal",
    "Gaza → Vaal",
    "Venda → JHB"
  ],

  travelDates: [
    "05 July Sunday 10:00am",
    "18 July Saturday 10:00am",
    "25 July Saturday 10:00am",
    "01 August Saturday 10:00am"
  ],

  fleet: [
    "15 Seater Taxi",
    "22 Seater Bus",
    "50 Seater Bus",
    "70 Seater Bus"
  ],

  pricing: {
    totalPrice: "anging From 479.99",
    deposit: "100" 
  },

  contact: {
    whatsapp: "27729792961",
    displayWhatsapp: "+27 72 979 2961",
    email: "arenaho@gmail.com"
  },

  banking: {
    bank: "Capitec",
    accountNumber: "1731201611",
    accountOwner: "A MUHALI",
    reference: "Your Name + WhatsApp Number"
  }, 

    publicKey: "",// The secret key (sk) will be blocked by Yoco when called directly from a browser for security reasons.
 

};